import type { MessageSearchConstraints } from '@aurora/shared-generated/types/graphql-schema-types';
import { ConversationStyle } from '@aurora/shared-generated/types/graphql-schema-types';
import { LastUpdateFilterMenuItem, RepliesFilterMenuItem } from '../../components/search/enums';

/**
 * Function to get past date value
 *
 * @param numberOfDays number of days
 * @return Returns a date as a string value in ISO format
 */
function getPastDate(numberOfDays: number): string {
  const currentDate = new Date();
  const pastDate = new Date(currentDate);
  pastDate.setDate(currentDate.getDate() - numberOfDays);
  return pastDate.toISOString();
}

/**
 * The Last Update filter menu item map
 */
const lastUpdateMenuItemMap: Record<LastUpdateFilterMenuItem, MessageSearchConstraints> = {
  [LastUpdateFilterMenuItem.PAST_DAY]: {
    conversationLastPostingActivityTime: {
      gte: getPastDate(1)
    }
  },
  [LastUpdateFilterMenuItem.PAST_WEEK]: {
    conversationLastPostingActivityTime: {
      gte: getPastDate(7)
    }
  },
  [LastUpdateFilterMenuItem.PAST_MONTH]: {
    conversationLastPostingActivityTime: {
      gte: getPastDate(30)
    }
  },
  [LastUpdateFilterMenuItem.PAST_YEAR]: {
    conversationLastPostingActivityTime: {
      gte: getPastDate(365)
    }
  }
};

/**
 * The Content Type filter menu item map
 */
const contentTypeMenuItemMap: Partial<Record<ConversationStyle, MessageSearchConstraints>> = {
  [ConversationStyle.Blog]: {
    conversationStyle: {
      eq: ConversationStyle.Blog
    }
  },
  [ConversationStyle.Forum]: {
    conversationStyle: {
      eq: ConversationStyle.Forum
    }
  },
  [ConversationStyle.Tkb]: {
    conversationStyle: {
      eq: ConversationStyle.Tkb
    }
  },
  [ConversationStyle.Idea]: {
    conversationStyle: {
      eq: ConversationStyle.Idea
    }
  },
  [ConversationStyle.Occasion]: {
    conversationStyle: {
      eq: ConversationStyle.Occasion
    }
  }
};

/**
 * The replies filter menu item map
 */
const repliesMenuItemMap: Record<RepliesFilterMenuItem, MessageSearchConstraints> = {
  [RepliesFilterMenuItem.WITH_SOLUTION]: {
    conversationSolved: {
      eq: true
    }
  }
};

export { lastUpdateMenuItemMap, contentTypeMenuItemMap, repliesMenuItemMap };
